import classNames from 'classnames/bind';
import styles from '@/styles/superstack/jobs/JobSort.module.scss';
import { handleChangeJobSortEvt } from '@/src/utils/tracking_analytics';
import IconLiDisc from '@/asset/superstack/svgs/icon-li-disc.svg';

const cx = classNames.bind(styles);

const JobSortWrapper = ({ sort = 'default', setSort }) => {
  const sortItems = [
    { key: 'default', name: '추천순' },
    { key: 'enroll', name: '최신순' },
  ];
  return (
    <div className={cx('sort-wrapper')}>
      {sortItems.map((sortItem) => {
        const isActive = sortItem.key === sort;
        return (
          <p
            key={sortItem.key}
            className={cx(['btn-sort', isActive ? 'active' : ''])}
            onClick={() => {
              if (!isActive) {
                handleChangeJobSortEvt(sortItem.key);
              }
              setSort(sortItem.key);
            }}
          >
            <IconLiDisc width={4} height={4} fill={isActive ? '#006DFF' : '#9E9E9E'} />
            <span>{sortItem.name}</span>
          </p>
        );
      })}
    </div>
  );
};

const JobFixedSortWrapper = ({ sortItem }) => {
  return (
    <div className={cx('sort-wrapper')}>
      <p className={cx(['btn-sort', 'active'])}>
        <IconLiDisc width={4} height={4} fill={'#006DFF'} />
        <span>{sortItem.name}</span>
      </p>
    </div>
  );
};

export { JobSortWrapper, JobFixedSortWrapper };
